import { koComponent } from '../../../ko-utils/index';
import * as siteConfig from '../../../site-config/config';
import createUuid from '../../../utils/uuid';
import tryMakeUrlDynamic from '../../../utils/tryMakeUrlDynamic';
import CardEditorBase from '../../../common/card-editor/CardEditorBase';

class VisualEventEditor extends CardEditorBase {
    constructor(params) {
        super('help');

        this.parent = params.parent;
        this.help = ko.unwrap(params.help);

        this.isSelected = ko.observable(params.isSelected || false);
        this.isSelected.subscribe(val => {
            if (val) {
                params.parent.setSelectedVisualEvent(this);
            } else {
                params.parent.setSelectedVisualEvent(null);
            }
        });

        let isNew = false;

        if (!this.help.id || !this.help.id()) {
            this.help.id(createUuid());

            isNew = true;
        }

        if (!this.help.element()) {
            this.help.element(new siteConfig.ElementDescriptor());
        }

        if (!this.help.element() || !this.help.element().query) {
            this.help.element(new siteConfig.ElementDescriptor());
        }

        this.help.element().query.subscribe(() => {
            this.showCardInWeb();
            this.autosave();
        });

        if (this.help.targetUrl()) {
            this.initAutosaveHandlers(this.help.targetUrl(), ['parametrized'])
        }

        document.addEventListener('cardElementQueried', (data) => {
            if (data.detail.cardId === this.help.id()) {
                if (!this.help.element()) {
                    this.help.element(new siteConfig.ElementDescriptor());
                }

                this.help.element().query(data.detail.query);

                var sv = new siteConfig.StringValue();
                sv.parametrized(tryMakeUrlDynamic(data.detail.url, this.parent.editorSettings.dontDetectDynamicUrlParts()));

                this.help.targetUrl(sv);
                this.initAutosaveHandlers(this.help.targetUrl(), ['parametrized'])
            }
        });
        this.listenToThisId('cardSelectorChanged', this.help.id(), data => {
            this.help.element().query(data.detail.query);

            this.autosave();
        });

        document.addEventListener('deselectCard', data => {
            if (data.detail.cardId === this.help.id()) {
                this.isSelected(false);
            }
        });

        document.addEventListener('relocateCard', data => {
            if (data.detail.cardId === this.help.id()) {
                this.locateElement();
            }
        });

        this.listenToThisIdOnce('closeCard', this.help.id(), data => {
            window.parent.postMessage({ action: 'close-card', helpId: this.help.id() }, '*');
        });

        this.listenToThisId('cardResumeEditing', this.help.id(), data => {
            this.showCardInWeb();
        });

        this.hasElementsSelected = ko.pureComputed(() => {
            if (this.help.element()) {
                return ko.unwrap(this.help.element().query) != null || ko.unwrap(this.help.element().id) != null;
            } else {
                return false;
            }
        });

        if (isNew) {
            this.locateElement();
        }

        this.initAutosaveHandlers(this.help, ['showDelayMs']);
    }

    get currentSelectorObservable() {
        return this.help.element().query;
    }

    findParentElement() {
        window.parent.postMessage({
            action: 'select-parent-element',
            helpId: ko.unwrap(this.help.id),
            selector: ko.unwrap(this.help.element().query),
            selectorSettings: this.parent.editorSettings.toJS()
        }, '*');
    }

    initAutosaveHandlers(baseObject, props) {
        const subscribeAndNotify = (prop) => {
            if (baseObject && baseObject[prop] && baseObject[prop].subscribe) {
                baseObject[prop].subscribe((val) => {
                    this.autosave();
                });
            }
        };

        Array.from(props).forEach(p => subscribeAndNotify(p));
        //subscribeAndNotify('blockedKeys');
        //subscribeAndNotify('showDelayMs');
    }

    showHelp(id) {
        window.parent.postMessage({
            action: 'pf_show_help',
            id
        }, '*');
    }

    positionPropChanged(propName) {
        this.changeCardProps();
    }

    locateElement() {
        this.isSelected(true);
        window.parent.postMessage({ action: 'locateElement', helpId: this.help.id(), helpJson: JSON.parse(JSON.stringify(this.help.toJS())), selectorSettings: this.parent.editorSettings.toJS() }, '*');
    }

    showCardInWeb() {
        this.isSelected(true);
        window.parent.postMessage({ action: 'showCard', helpId: this.help.id(), helpJson: JSON.parse(JSON.stringify(this.help.toJS())) }, '*');
    }

    changeCardProps() {
        window.parent.postMessage({ action: 'changeProps', helpId: this.help.id(), helpJson: JSON.parse(JSON.stringify(this.help.toJS())) }, '*');
        this.autosave();
    }

    autosave() {
        this.parent.autosave();
    }
}

export default koComponent('visual-event-editor', VisualEventEditor);